import { androidStoreAppUrl, appleStoreAppUrl } from "../../config";

const inGameUI = document.querySelector(".ui");
const externalLinkConfirmButton = document?.querySelector(
  ".external-site-confirm-button",
);
const homepageElement = inGameUI?.querySelector("#homepage");
const main = inGameUI?.querySelector("#main");
const eyeConditionsContainer = main?.querySelector(".eye-conditions-container");
const selectEyeConditionButton = homepageElement?.querySelector(
  ".select-eye-condition",
);
const findOutMoreButton = homepageElement?.querySelector(
  "#find-out-more-button",
);
const surveyButton = homepageElement?.querySelector(".survey");
const appleButton = homepageElement?.querySelector(".apple_store_button");
const googleButton = homepageElement?.querySelector(".google_play_button");

const donateButton = homepageElement?.querySelector("#donate-button");
const homeButton = main?.querySelector("#main-ui-home-button");
const externalSite = <HTMLElement>document?.querySelector("#external-site");
const homeButtonContainer = <HTMLElement>(
  document?.querySelector(".home__button-container")
);
const ui = <HTMLElement>document?.querySelector(".ui");

/* Functions */

/* Export */
export const Homepage = () => {
  selectEyeConditionButton?.addEventListener("click", () => {
    if (homeButtonContainer != null) {
      homeButtonContainer.classList.add("alignStart");
    }
    main?.classList.remove("space-between");
    eyeConditionsContainer?.classList.remove("hidden");
    homeButton?.classList.remove("hidden");
    homepageElement?.classList.remove("active");
    main?.classList.add("active");
  });

  findOutMoreButton?.addEventListener("click", () => {
    externalLinkConfirmButton?.setAttribute(
      "data-href",
      "https://www.rnib.org.uk/about-us/",
    );
    externalLinkConfirmButton!.id = "external-site-confirm-find-more";
    externalSite.style.display = "flex";
    ui.style.display = "none";
  });

  surveyButton?.addEventListener("click", () => {
    externalLinkConfirmButton?.setAttribute(
      "data-href",
      "https://forms.office.com/e/9KHusTbN15",
    );
    externalLinkConfirmButton!.id = "external-site-confirm-survey";
    externalSite.style.display = "flex";
    ui.style.display = "none";
  });

  appleButton?.addEventListener("click", () => {
    externalLinkConfirmButton?.setAttribute("data-href", appleStoreAppUrl);
    externalLinkConfirmButton!.id = "external-site-confirm-apple";
    ui.style.display = "none";
    externalSite.style.display = "flex";
  });

  googleButton?.addEventListener("click", () => {
    externalLinkConfirmButton?.setAttribute("data-href", androidStoreAppUrl);
    externalLinkConfirmButton!.id = "external-site-confirm-android";
    ui.style.display = "none";
    externalSite.style.display = "flex";
  });

  donateButton?.addEventListener("click", () => {
    externalLinkConfirmButton?.setAttribute(
      "data-href",
      "https://www.rnib.org.uk/get-involved/donate/",
    );

    externalLinkConfirmButton!.id = "external-site-confirm-donate";
    ui.style.display = "none";
    externalSite.style.display = "flex";
  });
};

export default Homepage;
